export var historianConstant: any = {
    0: "All",
    1: "None",
    2: "HourlyStatistics",
    3: "DailyStatistics"
}